import { useCallback } from 'react';
import { trackAnalytics } from 'common/components/CopyMagic/shared/dataHelpers';
import { useConfigContext } from 'common/components/CopyMagic/contexts';
import { useMessagesContext } from 'common/components/CopyMagic/contexts/MessagesContext';
import { MESSAGE_DATA_ROLES } from 'common/components/CopyMagic/constants';

const useTrackContactSupportClicked = () => {
  const { productEvents } = useConfigContext();
  const { findMessagesBy } = useMessagesContext();

  const trackCallback = useCallback(() => {
    const trackProductAnalytics = trackAnalytics(productEvents);
    trackProductAnalytics('Contact Support Clicked', {
      'User Messages Count': findMessagesBy({ role: MESSAGE_DATA_ROLES.USER }).length,
    });
  }, [productEvents, findMessagesBy]);

  return trackCallback;
};

export default useTrackContactSupportClicked;
